"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _interopRequireWildcard = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sysRoleAcl = exports.sysAclTable = exports.sysAclColumn = void 0;
var _DaoServiceClientES6Adapter = _interopRequireWildcard(require("@/utils/daoService/DaoServiceClientES6Adapter"));
var _request = _interopRequireDefault(require("@/utils/request"));
var sysRoleAcl = exports.sysRoleAcl = _DaoServiceClientES6Adapter.default.QSysRoleAcl;
var sysAclTable = exports.sysAclTable = _DaoServiceClientES6Adapter.default.QSysAclTable;
var sysAclColumn = exports.sysAclColumn = _DaoServiceClientES6Adapter.default.QSysAclColumn;
/** 查询 */
sysRoleAcl.querySysRoleAclList = function (query) {
  if (query.keyword === '') {
    query.keyword = undefined;
  }
  return sysRoleAcl.select(sysRoleAcl.fieldContainer()).where(sysRoleAcl.roleId.eq(_DaoServiceClientES6Adapter.___).and(sysRoleAcl.tableName._like$_(query.keyword))).paging(query.currentPage, query.pageSize).sorting(sysRoleAcl.createTime.desc()).execute(query);
};

/** 查询 */
sysRoleAcl.saveSysRoleAcls = function (data) {
  return sysRoleAcl.save(data);
};

/** 根据主键删除*/
sysRoleAcl.deleteSysRoleAcls = function (id) {
  return sysRoleAcl.deleteById(id);
};
/** 获取表名*/
sysAclTable.querySysAclTable = function (query) {
  return sysAclTable.select(sysAclTable.fieldContainer()).where(sysAclTable.tableName._like$_(query.keyword)).paging(query.currentPage, query.pageSize).sorting(sysAclTable.createTime.desc()).execute(query);
};
/** 获取字段*/
sysAclColumn.querySysAclColumn = function (query) {
  return sysAclColumn.select(sysAclColumn.fieldContainer()).where(sysAclColumn.columnName._like$_(query.keyword).and(sysAclColumn.aclTableId.eq(_DaoServiceClientES6Adapter.___))).paging(query.currentPage, query.pageSize).sorting(sysAclColumn.createTime.desc()).execute(query);
};
/** 刷新单个角色*/
sysRoleAcl.refreshRole = function (query) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysDataAuthority/refreshRole',
    method: 'get',
    params: query
  });
};

/** 刷新所有*/
sysRoleAcl.refreshAllRole = function () {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysDataAuthority/refreshAllRole',
    method: 'get'
  });
};